export function validatePIS(pis: string): boolean {
  if (!pis) return false

  const cleanedPis = pis?.replace(/\D/g, '')

  if (!/^\d{11}$/.test(cleanedPis)) return false

  if (/^(\d)\1{10}$/.test(cleanedPis)) return false

  const multipliers = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  let add = 0

  for (let i = 0; i < 10; i++) {
    add += parseInt(cleanedPis.charAt(i)) * multipliers[i]
  }

  const remnant = add % 11
  const checkDigit = remnant < 2 ? 0 : 11 - remnant

  return checkDigit === parseInt(cleanedPis.charAt(10))
}
